import SectionSideCarousel from './SectionSideCarousel';
export default SectionSideCarousel;
